import Enum from './enum'

class TenderState extends Enum
{
  constructor(value) {
    super(value);
  }
}

TenderState.init({
  NONE: "None",
  DRAFT: "Draft",
  APPROVING: "Approving",
  APPROVED: "Approved",
  DECLINED: "Declined",
  RECEIVING_REQUESTS: "GettingReq",
  PROCESSING_REQUESTS: "ProcessingReq",
  WAITING_PROTOCOLS: "WaitingGettingReqProtocol",
  IN_WORK: "InWork",
  CLOSED: "Closed"
}, {
  NONE: "tender-status.empty",
  DRAFT: "tender-status.draft",
  APPROVING: "tender-status.approving",
  APPROVED: "tender-status.approved",
  DECLINED: "tender-status.declined",
  RECEIVING_REQUESTS: "tender-status.receiving-requests",
  PROCESSING_REQUESTS: "tender-status.processing-requests",
  WAITING_PROTOCOLS: "tender-status.waiting-protocols",
  IN_WORK: "tender-status.in-work",
  CLOSED: "tender-status.closed"
});

export default TenderState;
